import { render, staticRenderFns } from "./BasicExamFinding.vue?vue&type=template&id=6c232c8c"
import script from "./BasicExamFinding.vue?vue&type=script&lang=js"
export * from "./BasicExamFinding.vue?vue&type=script&lang=js"
import style0 from "./BasicExamFinding.vue?vue&type=style&index=0&id=6c232c8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports